import type { ControlPosition } from "leaflet";
import { useMap } from "react-leaflet";
import { MapControlBase } from "src/components/map/MapControlBase";
import type { GeopuntLocation } from "src/types/geopunt";
import { LocationAutocomplete } from "src/location/LocationAutocomplete";
import { IsEnabled } from "src/components/permissions";
import { usePermissions } from "src/hooks";
import { ErrorBoundary } from "react-error-boundary";
import { Suspense } from "react";
import { PERMISSION } from "src/types";

interface Props {
  position?: ControlPosition;
}

export function SearchControl(props: Props) {
  const { position } = props;
  return (
    <MapControlBase position={position}>
      <ErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <LoadData {...props} />
        </Suspense>
      </ErrorBoundary>
    </MapControlBase>
  );
}

function LoadData(props: Props) {
  const { data: permissions } = usePermissions();
  const map = useMap();

  function onSelectLocation(location: GeopuntLocation) {
    if (!map) return;

    map.fitBounds(
      [
        [location.bbox.LowerLeft.Lat_WGS84, location.bbox.LowerLeft.Lon_WGS84],
        [location.bbox.UpperRight.Lat_WGS84, location.bbox.UpperRight.Lon_WGS84],
      ],
      {
        maxZoom: 18,
      }
    );
  }

  return (
    <IsEnabled permission={permissions?.searchBar.search || PERMISSION.DISABLED}>
      <LocationAutocomplete onSelectLocation={onSelectLocation} />
    </IsEnabled>
  );
}
